<template>
  <div class="form-row d-info d-frame">
    <h3>Słuchaj i czytaj gdzie chcesz!</h3>
    <p>W Empik Go masz dostęp do ponad 20 000 Audiobooków, Podcastów i Seriali Audio oraz 30 000 E- booków w wygodnym abonamencie.</p>
    <p>Z abonamentem w Empik Go Twoja biblioteka już nigdy nie będzie pusta. Wybierz ofertę najlepiej dopasowaną do Twoich potrzeb.</p>
    <p>Do Twojego konta może być przypisany więcej niż jeden rodzaj abonamentu.</p>
    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <h3>Instrukcja użycia:</h3>
      <ul class="decimal">
        <li>Wejdź na <a href="https://www.empik.com/gofree" target="_blank" rel="nofollow">empik.com/gofree</a></li>
        <li>Wpisz kod zasilenia podany na paragonie</li>
        <li>Zaloguj się lub zarejestruj na <a href="https://www.empik.com" target="_blank" rel="nofollow">empik.com</a></li>
        <li>Pobierz aplikację Empik Gona swój smartfon</li>
      </ul>
      <p>Korzystaj z tysięcy tytułów dostępnych w naszej bibliotece!</p>
      <h3>Warunki korzystania:</h3>
      <p>
        Bezzwrotna (z wyjątkiem przypadków określonych przez prawo). Nieprzeznaczona do odsprzedaży. Korzystanie wymaga konta na empik.com. Brak możliwości zastąpienia karty, jeśli zostanie ona
        zgubiona, skradziona lub wykorzystana bez pozwolenia. Korzystanie z karty oznacza akceptację warunków zamieszczonych na stronie <a href="https://www.empik.com/karta-empikgo-euronet-regulamin" target="_blank" rel="nofollow">www.empik.com</a>
      </p>
      <p>UWAGA! KOD WAŻNY DO 30.08.2023!</p>
      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoEmpikGo',
  data () {
    return {
      showMore: false
    }
  }
}
</script>
